// extracted by mini-css-extract-plugin
export default {"login_root":"MilgoLoginStyles_login_root__sKi2H","logo":"MilgoLoginStyles_logo__YzP13","formPanel":"MilgoLoginStyles_formPanel__HtT-3","error":"MilgoLoginStyles_error__UTzcs"};